
import React, { useState, useEffect } from 'react';
import { ToggleArrow } from 'components/toggle-arrow';
import styled from 'styled-components';
import { LoadingAnimation } from 'components/loading';

const SChildren = styled.div`
    display: ${(props: { isVisible: boolean; }) => props.isVisible ? 'block' : 'none'};
`;

interface IAccordionProps {
    text: string;
    id?: string;
    collapse: boolean;
    children: React.ReactNode | React.ReactNodeArray;
    onClick?: (e: React.MouseEvent<HTMLDivElement>, object: any) => void;
}

const AccordionNew = (props: IAccordionProps) => {
    const { collapse, text, id, children } = props;
    const [isCollapse, setIsCollapse] = useState(collapse);

    useEffect(() => {
        if (collapse !== undefined) {
            if (!collapse) {
                if (collapse) {
                    setIsCollapse(true);
                }
            } else {
                setIsCollapse(true);
            }
        }

    }, []);

    useEffect(() => {
        setIsCollapse(!isCollapse);
    }, [collapse]);

    const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
        setIsCollapse(!isCollapse);
        if (typeof props.onClick === 'function') {
            props.onClick(e, { id, isCollapse });
        }
    }

    const onToggle = () => {
        if (typeof props.onClick !== 'function') {
            setIsCollapse(!isCollapse);
        }
    }


    return (
        <div className="grid-wrapper" id={`accordion-${props.id}`}>
            <div className="accordion-title" onClick={handleClick}>
                <h3 className="title-blue-underline">{text}</h3>
                <ToggleArrow
                    expandedText=""
                    nonExpandedText=""
                    isExpanded={isCollapse ? true : false}
                    onToggle={onToggle}
                />
            </div>
            <SChildren isVisible={isCollapse}>
                {children ? children : <LoadingAnimation inlineLoader={true} />}
            </SChildren>
        </div>
    )

}
export default AccordionNew;